'use strict';

import angular from 'angular';
import constants from '../../app/app.constants.js';
import util from '../util/util.module.js';
import ngCookies from 'angular-cookies';
import { authInterceptor } from './interceptor.service.js';
import { routerDecorator } from './router.decorator.js';
import { AuthService } from './auth.service.js';
import { GroupAuthService } from './groupAuth.service.js';

import uiRouter from 'angular-ui-router';

function addInterceptor($httpProvider) {
  $httpProvider.interceptors.push('authInterceptor');
}
addInterceptor.$inject = ['$httpProvider'];

export default angular.module('georgeApp.auth',
  [constants, util, ngCookies, uiRouter])
  .factory('authInterceptor', authInterceptor)
  .run(routerDecorator)
  .factory('AuthSvc', AuthService)
  .factory('GroupAuthSvc', GroupAuthService)
  .config(['$httpProvider', addInterceptor])
  .name;
